module.exports = __webpack_public_path__ + "static/skull_lord-24d87e0aeda24afbb6578ae5a45fc9a2.png";